/* eslint-disable @typescript-eslint/no-explicit-any */
export const CustomStyles = {
  control: (base: any) => {
    return {
      ...base,
      // override the focus border
      boxShadow: 'none',
      // set font size
      fontSize: 14,
    };
  },
  menu: (base: any) => {
    return {
      ...base,
      // set font size
      fontSize: 14,
      // overlay floating labels
      zIndex: 11,
    };
  },
  multiValueLabel: (base: any) => ({
    ...base,
    // set font size
    fontSize: 12,
  }),
  option: (base: any) => ({
    ...base,
    // set font size
    fontSize: 14,
  }),
  valueContainer: (base: any) => ({
    ...base,
    // make it fixed-height so it does not expand vertically
    // this results in the options getting ellipses
    flexWrap: 'nowrap',
    // make room for the floating label
    paddingTop: 5,
  }),
  placeholder: (base: any) => ({
    ...base,
    // avoid multi-line input even with a long placeholder
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
  }),
};
export const CustomTheme = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#427aa1',
  },
});
/* eslint-enable @typescript-eslint/no-explicit-any */
